<template v-if="isProcessingCard">
    <div class="vl-agenda-item kl-map-request-card">
        <div class="vl-agenda-item__text" itemprop="description">
            {{mapRequestCard.processingLabel}}
            <div class="vl-loader" aria-busy="true"/>
        </div>
    </div>
</template>
<kl-router-link v-else class="vl-agenda-item kl-map-request-card" :to="to" :params="{ id: mapRequestCard.id }">
    {{mapRequestCard.mapRequestType}} {{mapRequestCard.type}}
    <h3 class="vl-agenda-item__title" itemprop="name">
        {{mapRequestCard.reference}}
    </h3>
    <div class="vl-agenda-item__text" itemprop="description">
        {{mapRequestCard.status}}
    </div>
    <div class="vl-agenda-item__note">
        <div v-if="mapRequestCard.mapRequestType">Type aanvraag: {{ requestType }}</div>
        <div v-if="mapRequestCard.dateReceived">Aangevraagd op {{DateUtil().formatDate(mapRequestCard.dateReceived) }}</div>
        <div v-if="mapRequestCard.organisation">Aanvrager: {{mapRequestCard.organisation}}</div>
        <div v-if="mapRequestCard.startDate">Geplande start werken op {{DateUtil().formatDate(mapRequestCard.startDate) }}</div>
    </div>
</kl-router-link>

<vl-u-spacer mod-xsmall />
